import { styled } from '@mui/material';

export const CardItemWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  backgroundColor: '#f5f5f5',
  paddingTop: 12,
  paddingBottom: 12,
  paddingLeft: 24,
  paddingRight: 24,
  marginTop: 24
}));
export const CardInfo = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  height: 24
}));
export const CardNumber = styled('div')(({ theme }) => ({
  display: 'inline-block',
  fontFamily: 'FuturaLTPro-Medium',
  fontSize: '14px',
  fontWeight: 'normal',
  lineHeight: 1.14,
  letterSpacing: '1px',
  color: '#000000',
  marginLeft: 24,
}));
export const CardLogo = styled('img')(({ theme }) => ({
  display: 'inline-block',
}));
export const ExpiredCard = styled('div')(({ theme }) => ({
  display: 'flex',
  height: 20,
  cursor: 'pointer'
}));

export const ExpireDateWrapper = styled('div')(({ theme }) => ({
  color: '#999',
  fontSize: '14px',
  fontFamily: 'FuturaLTPro-Medium',
  lineHeight: 1.14,
  fontWeight: 'normal',
  paddingLeft: 16
}));
